<ng-template #content let-modal>
  <div trapFocus style="overflow-y: auto">
    <div class="modal-header ml-auto align-items-center">
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
        ngbAutofocus
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-3 validate-lb" id="lightbox" style="height: 75vh">
      <div
        class="row"
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
          height: 80%;
        "
      >
        <div class="col-12">
          <div class="h2-eq" style="text-align: center">
            <h2>{{ titleText }}</h2>

            <h3 style="margin-top: 50px; margin-bottom: 50px">
              {{ subTitleText }}
            </h3>

            <button
              *ngFor="let itm of supportedLanguages"
              class="btn-validate text-uppercase"
              (click)="selectLanguage(itm.language)"
            >
              {{ itm.caption }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer text-uppercase"></div>
  </div>
</ng-template>
